<template>
  <div
    :id="'qualifiers-event-upcoming-' + event.id"
    ref="community_event"
    :class="'community_event' + (event.ec_series ? ' big' : '') + (theme === 'light' ? ' light_theme' : '')"
  >
    <div class="left-card">
      <template v-if="event.ec_status !== 'past'">
        <paid-event-card-banner
          v-if="event.is_paid_tournament"
          :event="event"
          @click="toggleEventCard()"
        />
        <div v-else-if="!event.ec_series && event.ec_prize" class="event-banner-container" @click="toggleEventCard()">
          <div class="event-banner-row" :style="(event.ec_prize && event.ec_prize.length > 7) ? 'max-width: 151px;' : ''">
            <div class="prizing-panel" :style="(event.ec_prize && event.ec_prize.length > 7) ? 'flex-wrap: wrap;' : ''">
              <span class="price" :style="(event.ec_prize && event.ec_prize.length > 7) ? 'margin-top: -4px; margin-right: 0;' : ''"> {{ event.ec_prize }} </span>
              <span v-if="event.ec_prize && event.ec_prize.length > 7" class="desc" style="margin-left: 15px; margin-top: -9px;">prize pool</span>
              <span v-else class="desc">prize<br>pool</span>
            </div>
          </div>
        </div>
      </template>
      <a
        v-if="!event.ec_series && ((!event.ec_prize && !event.is_paid_tournament) || event.ec_status === 'past')"
        class="community_event_help"
        :data-id="event.id"
        @click="toggleEventCard()"
      >
        <img class="lazyload" :data-src="contentCloudFront('/assets/v4/event/event-card-info.png')" width="20" height="20">
      </a>
      <div
        v-if="page === 'hub_landing' && !event.ec_series && !event.ec_is_featured && additionalData.tab === 'event' && additionalData.is_leader"
        class="community_event_actions"
        :data-id="event.id"
      />
      <div
        v-if="page === 'hub_series' && additionalData.is_leader"
        class="community_event_actions"
        :data-id="event.id"
        style="background-image: unset; font-size: 11px"
      >x</div>
      <div
        :class="'community_event_tag ' + event.ec_status"
        :style="(page === 'hub_series' && additionalData.is_leader) ? 'right: 25px;' : ''"
      >{{ event.ec_status }}</div>
      <a class="community_event_bg" :href="event.ec_url">
        <img v-if="event.ec_series" class="lazyload" :data-src="event.background_url" @error="replaceEventCardBackgroundDefault">
        <img v-else :data-src="event.ec_img" width="216" height="125" style="max-height: 125px; object-fit: cover;" class="lazyload" @error="replaceEventCardBackgroundDefault">
      </a>
      <template v-if="event.ec_series">
        <div class="community_event_info">
          <a class="community_event_title" :href="event.ec_url">{{ event.title }}</a>
          <p class="community_event_desc">{{ event.description }}</p>
          <a class="cr_btn orange" :href="event.ec_url">
            <span>View Event Series</span>
          </a>
        </div>
        <p v-if="event.tournaments.length > 1" class="community_event_num">{{ event.tournaments.length + ' events' }}</p>
        <p v-else class="community_event_num">{{ event.tournaments.length + ' event' }}</p>
      </template>
      <template v-else>
        <div :class="'community_event_info' + (isIntelCard ? ' community_event_intel_info' : '')">
          <a
            class="community_event_title left_event_title"
            :title="event.ec_event_title"
            :href="event.ec_url"
          >{{ event.ec_event_title }}</a>

          <div class="community_event_desc">
            <template v-if="!event.ec_series">
              <template v-if="event.ec_datetime !== 'TBD'">
                <div class="community_event_desc_line">
                  <img :data-src="contentCloudFront('/assets/v4/event_card/light_card_calendar.png')" class="event_desc_icon lazyload">
                  {{ event.ec_date }}
                </div>
                <div class="community_event_desc_line">
                  <img v-if="event.ec_time" :data-src="contentCloudFront('/assets/v4/event_card/light_card_time.png')" class="event_desc_icon lazyload">
                  {{ event.ec_time ? event.ec_time : '' }}
                </div>
              </template>
              <template v-else>
                <div class="community_event_desc_line">
                  <img :data-src="contentCloudFront('/assets/v4/event_card/light_card_calendar.png')" class="event_desc_icon lazyload">
                  Date TBD
                </div>
                <div class="community_event_desc_line">
                  <img :data-src="contentCloudFront('/assets/v4/event_card/light_card_time.png')" class="event_desc_icon lazyload">
                  Time TBD
                </div>
              </template>
              <div class="community_event_desc_line">
                <img :data-src="contentCloudFront('/assets/v4/event_card/light_card_game.png')" class="event_desc_icon lazyload" style="height: 9px">
                {{ event.ec_game + '; ' + event.ec_team_size + ' ' + (appConfig.env === 'production' && event.id === 38973 ? 'CUSTOM REBIRTH RESURGENCE' : event.ec_event_type) }}
              </div>
              <div v-if="event.is_paid_tournament" class="community_event_desc_line">
                <img :data-src="contentCloudFront('/assets/v4/event_card/light_card_prize.svg')" class="event_desc_icon prize lazyload">
                {{ eventPrizeText }}
              </div>
            </template>
          </div>
          <template v-if="isIntelCard">
            <div class="community_event_intel_bar" />
            <div class="community_event_intel_link">
              <a :href="event.ec_url_view" :data-id="event.id" target="_blank">View Event</a>
            </div>
            <a class="community_event_intel_button" :href="event.ec_url_register" :data-id="event.id" target="_blank">Manage Team</a>
          </template>
          <template v-else>
            <div class="community_event_bar" />
            <div
              v-if="event.ec_status !== 'past'"
              :class="'community_event_status ' + event.ec_status"
            >
              <span class="event_type">{{ tournamentType }}</span>
              <span class="event_desc">{{ tournamentDesc }}</span>
            </div>
            <a
              class="community_event_link"
              :class="{ small: isSmallText }"
              :data-id="event.id"
              :href="event.ec_community_event.url"
              :disabled="event.ec_community_event.disabled"
              target="_blank"
            >
              {{ event.ec_community_event.text }}
            </a>
            <div class="community_event_bar_2" />
          </template>
        </div>
      </template>
    </div>
    <div v-if="!event.ec_series" class="community_data" style="display:none;">
      <div class="community_data_top">
        <div class="community_data_menu">
          <a class="community_data_close" :data-id="event.id" @click="toggleEventCard()">
            <i class="sp-ic-sm-event-card-close sp-ic-sm-event-card-close-12x12" />
          </a>
          <div class="section">
            <div v-if="event.ec_platform.pc === 'pc'" class="community_data_platform">
              <i :class="isLightTheme? 'sp-ic-sm-event-card-pc-black' : 'sp-ic-sm-event-card-pc'" />
            </div>
            <div v-if="event.ec_platform.ps4 === 'ps4'" class="community_data_platform">
              <i :class="isLightTheme? 'sp-ic-sm-event-card-ps-black' : 'sp-ic-sm-event-card-ps'" />
            </div>
            <div v-if="event.ec_platform.xbox === 'xbox'" class="community_data_platform">
              <i :class="isLightTheme? 'sp-ic-sm-event-card-xbox-black' : 'sp-ic-sm-event-card-xbox'" />
            </div>
          </div>
        </div>
        <h2 class="community_event_title right-description" v-html="event.ec_description" />
        <div v-if="event.ec_host_by" class="community_data_section">
          <div class="community_data_section_icon">
            <i class="sp-ic-sm-event-card-host" />
          </div>
          <p class="community_event_desc">{{ event.ec_host_by }}</p>
        </div>
        <div v-if="event.ec_who_can_join" class="community_data_section">
          <div class="community_data_section_icon">
            <img class="lazyload" :data-src="contentCloudFront('/assets/v4/event/event-card-status.png')">
          </div>
          <p class="community_event_desc">{{ event.ec_who_can_join }}</p>
        </div>
      </div>
      <div class="community_data_bot">
        <a class="community_data_link" target="_blank" :href="event.ec_url_rules" title="Rules">VIEW RULES</a>
        <a class="community_data_link" target="_blank" :href="event.ec_url_share">SHARE ON TWITTER</a>
        <a v-if="event.ec_google_calendar !== 'TBD'" class="community_data_link" target="_blank" :href="event.ec_google_calendar">ADD ON GOOGLE CALENDAR</a>
        <a class="cr_btn orange" :href="event.ec_url">
          <span>Visit Event Page</span>
        </a>
      </div>
    </div>
    <template v-if="event.ec_allow_register || event.ec_is_fw">
      <template v-if="event.ec_display == 1">
        <template v-if="event.ec_total_registered != 0">
          <div v-if="event.ec_total_registered == 1" class="community_event_num">{{ event.ec_total_registered + ' TEAM HAS SIGNED UP' }}</div>
          <div v-else class="community_event_num">{{ event.ec_total_registered + ' TEAMS HAVE SIGNED UP' }}</div>
        </template>
        <div v-else class="community_event_num" />
      </template>
      <template v-else-if="event.ec_display == 2">
        <template v-if="event.ec_user_registered != 0">
          <div v-if="event.ec_user_registered == 1" class="community_event_num">{{ event.ec_user_registered + ' PLAYER HAS SIGNED UP' }}</div>
          <div v-else class="community_event_num">{{ event.ec_user_registered + ' PLAYERS HAVE SIGNED UP' }}</div>
        </template>
        <div v-else class="community_event_num" />
      </template>
      <template v-else>
        <div class="community_event_num" />
      </template>
    </template>
    <div v-if="!event.ec_allow_register && !event.ec_is_fw && !event.ec_series" class="community_event_num" />
  </div>
</template>
<script>

import { component } from '../../mixins/component';
import PaidEventCardBanner from './PaidEventCardBanner';

export default {
  components: { PaidEventCardBanner },
  mixins: [component],
  props: {
    page: {
      type: String,
      default: '',
    },
    event: {
      type: Object,
      default() {
        return {

        };
      },
    },
    additionalData: {
      type: Object,
      default() {
        return {

        };
      },
    },
    theme: {
      type: String,
      default: '',
    },
    isIntelCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowLeftCard: true,
    };
  },
  computed: {
    eventPrizeText: function() {
      if (!this.event.is_paid_tournament) {
        return '';
      }
      if (
        this.event.paid_event_type === 'static' ||
        !this.event.award_pool_amount
      ) {
        return `${this.formattedPrize} Prize Pool`;
      }
      return `${this.formattedPrize} Prize Pool + Pot Bonus`;
    },
    formattedPrize: function() {
      const prizePool = this.event.prize_pool_amount;
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      });
      return formatter.format(prizePool);
    },
    tournamentType: function() {
      if (this.event.ec_status === 'live') {
        return 'live';
      }
      if (!this.event.is_paid_tournament) {
        return 'free';
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
      });
      return formatter.format(this.event.entry_fee);
    },
    tournamentDesc: function() {
      if (this.event.ec_status === 'live') {
        return 'watch\nnow';
      }
      if (!this.event.is_paid_tournament) {
        return 'play\nnow';
      }
      return 'entry\nfee';
    },
    isSmallText: function() {
      return this.event.ec_community_event && (this.event.ec_community_event.text === 'REGISTRATION CLOSED' || this.event.ec_community_event.text === 'HOW TO PARTICIPATE');
    },
  },
  methods: {
    toggleEventCard() {
      const elem = $(this.$refs.community_event);
      elem.animate({
        height: 'toogle',
      }, 'slow');
      if (this.isShowLeftCard) {
        elem.find('.left-card').fadeOut('5000');
        elem.find('.community_data').fadeIn('5000');
      } else {
        elem.find('.community_data').fadeOut('5000');
        elem.find('.left-card').fadeIn('5000');
      }
      this.isShowLeftCard = !this.isShowLeftCard;
    },
  },
};
</script>
